import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../../../actions/ManagePrescriptionAction";
import {
  getDoctorList,
  getSpecialityList,
} from "../../../../../reducers/symptom.api";
import PrescriptionDropDown from "../../../../PrescriptionDropdown/PrescriptionDropDown";
import { PrescriprionContext } from "../../../PrintPrescription";
import styles from "./index.module.scss";

function Referal() {
  const dispatch = useDispatch();
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);
  const [departments, setDepatments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  let [referalData, setReferalData] = useState({});
  let [IsSpecialityChange, setIsSpecialityChange] = useState(false);
  const [form, setForm] = useState({
    speciality: "",
    referral: "",
    note: "",
  });

  const handleItemChange = ({ key, value }) => {
    handleWholeData(key,value);
   
    if (key === "speciality") {
      const selectedDepartment = departments.filter(
        (item) => item.departmentName === value
      )[0];
      getDoctorList(selectedDepartment.departmentId, (res) => setDoctors(res));
      setIsSpecialityChange(true);
      console.log("referalData",referalData)
    }
    else
    {
      setIsSpecialityChange(false);
    }
    handleChangeData({ key, value });
    
  };


  const handleChangeData = ({ key, value }) => {
    setReferalData({...referalData,[key]:value});
  };

  useEffect(() => {
    getSpecialityList((res) => setDepatments(res));
  }, []);

  console.log("referalData",referalData)
  return (
    <div className={styles.referal_container}>
      <div className={styles.form}>
        <div className={styles.caption}>Specialty</div>
        <PrescriptionDropDown
          value={referalData?.speciality}
          onChange={(e) => {
            handleItemChange({ key: "speciality", value: e });
          }}
          defaultPlaceH="Select Specialty"
          DataItem={departments.map((item) => item.departmentName)}
        />
      </div>

      {referalData?.speciality ? (
        <div className={styles.form}>
          <div className={styles.caption}>Referral</div>
          <PrescriptionDropDown
            value={IsSpecialityChange?"":referalData?.referral}
            onChange={(e) => {
              handleItemChange({ key: "referral", value: e });
            }}
            defaultPlaceH="Select referral"
            DataItem={doctors.map((item) => item.doctorName)}
          />
        </div>
      ) : null}

      {referalData?.speciality ? (
        <div className={styles.form}>
          <div className={styles.caption}>Note</div>
          <input
            value={referalData?.referral_note}
            onChange={(e) => {
              handleItemChange({ key: "referralNote", value: e.target.value });
            }}
            className={styles.form_input}
            type="text"
            placeholder="Enter note here"
          />
        </div>
      ) : null}
    </div>
  );
}

export default Referal;
